// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nNAkF","left":"styles_left__hZWC6","right":"styles_right__XtPWw"};